<template>
  <BtnAComponent texto="Descargar Constancia" @click="createPDFsubmitt" />
  <ModalContenedorComponent v-if="dialog" :cerrar="closeDialog">
    <ModalMultaPagadaComponent :obj="pdfSubmitt" titulo="Pago de Multa" />
  </ModalContenedorComponent>
</template>
<script>
import InfractionService from "@/services/infractions/infractionService";
import ModalContenedorComponent from "../Modales/ModalContenedorComponent.vue";
import BtnAComponent from "./BtnAComponent.vue";
import ModalMultaPagadaComponent from "../Modales/ModalMultaPagadaComponent.vue";
import InfractorService from "@/services/infractions/infractorService";
export default {
  name: "BtnDownloadMultComponent.vue",
  data() {
    return {
      pdfSubmitt: null,
      dialog: false,
    };
  },

  props: {
    body: Object,
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },

    //METODO PARA BUSCAR LA INFORMACION PARA MOSTRAR EN MODAL, PARA DERCARGAR CONSTANCIA CUANDO SE PRESENTA EL TRAMITE
    async createPDFsubmitt() {
      const response = await InfractionService.getInfractionById(
        this.body?.infractionId
      );
      const info = await InfractorService.getInfoByToken();
      if (!response.success || !info.success) {
        //usar toast
        return;
      }

      const data = response.data.data;
      this.pdfSubmitt = {
        firstname: info.data.firstname,
        lastname: info.data.lastname,
        cuil: info.data.cuil,
        procedure: this.body.IdReferenciaOperacion,
        actNumber:
          data.infraction.infraType?.type +
          data.infraction.act.act_number.toString().padStart(6, "0"),
        fecha: new Date(),
        price: 100,
      };
      this.dialog = true;
    },
  },
  components: {
    ModalContenedorComponent,
    BtnAComponent,
    ModalMultaPagadaComponent,
  },
};
</script>
<style scoped>
@media (max-width: 770px) {
}
</style>
